import GrabMulti from "./GrabMulti";
import GrabBanner from "./GrabBanner";
import { lazy, Suspense, useEffect, useState } from "react";

const GrabModule = lazy(() => import("./GrabModule"));
const GrabFeature = lazy(() => import("./GrabFeature"));
const BoltNeed = lazy(() => import("../boltClone/BoltNeed"));
const BoltDrive = lazy(() => import("../boltClone/BoltDrive"));
const BoltJourney = lazy(() => import("../boltClone/BoltJourney"));
const BoltWhiteLabel = lazy(() => import("../boltClone/BoltWhiteLabel"));
const BoltGlobal = lazy(() => import("../boltClone/BoltGlobal"));
const ShuttleAppreciation = lazy(() => import("../../shuttle_software/ShuttleAppreciation"));
const TaxiFaq = lazy(() => import("../../taxiDispatchSoftware/TaxiFaq"));


const HeadData = {
  title: "Grab Clone - Manage Multiple Taxi Services Across Vietnam",
  description: "Offer diverse taxi and transportation services under one powerful Grab-style solution, designed specifically for Vietnam’s dynamic mobility market. Simplify operations and gain full control over your ride-hailing business across multiple cities.",
  image: "/assets/home/grab-banner.webp",
  backImage: "/assets/home/grab-banner-back.webp",
  btn: "get free Demo",
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "Grab Clone App",
        slug: ""
      },
    ]
  }
};

const multiData = {
  label: "Best UI & UX",
  titlePart1: "Grab Clone App",
  titlePart2: "by Mobility Infotech",
  subHead: "Empower Your Taxi Business in Vietnam with One Complete Solution",
  description: "Launch an advanced, feature-packed Grab clone taxi app designed for the Vietnamese market. Whether it’s motorbike taxis (xe ôm), car rides, parcel deliveries, or more, our all-in-one platform simplifies your daily operations, enhances the rider experience, and gives your business the flexibility to grow across Vietnam — from Hanoi to Ho Chi Minh City.",
  btn: "get free demo",
  image: "/assets/home/grab-multi-img.webp"
}

const moduleData = {
  titlePart1: "Effective Modules Of",
  titlePart2: "Grab Clone App",
  description: "The modules in the Grab clone app solution are streamlined, giving personalized experiences to the respective users and connecting them in real-time, causing the multi-service business to be seamlessly managed.",
  activateKey: "customer app",

  tabs: [
    {
      name: "customer app",
      image: "/assets/home/bolt-developement-1.webp",
      boxes: [
        {
          image: "/assets/home/grab-mod-icon-1.webp",
          head: "Instant or Schedule",
          para: "Allow passengers to book rides instantly for quick travel or schedule rides in advance — perfect for airport transfers or important appointments anywhere in Vietnam.",
        },
        {
          image: "/assets/home/grab-mod-icon-2.webp",
          head: "In-app Notifications",
          para: "Customers receive real-time updates about their ride status, driver details, promotions, and important alerts — all in Vietnamese for ease of use.",
        },
        {
          image: "/assets/home/grab-mod-icon-3.webp",
          head: "Social Login",
          para: "New users can quickly register using their Zalo, Facebook, or Google accounts, saving time and making the process familiar for Vietnamese customers.",
        },
        {
          image: "/assets/home/grab-mod-icon-4.webp",
          head: "Share Feedback",
          para: "After completing a ride, passengers can easily rate the driver and share feedback, helping maintain high service quality across the platform.",
        },
      ]
    },
    {
      name: "driver App",
      image: "/assets/home/bolt-developement-2.webp",
      boxes: [
        {
          image: "/assets/home/grab-mod-icon-17.webp",
          head: "Go Offline",
          para: "Drivers have complete control over their availability. They can go online to accept rides or offline when they are unavailable, providing flexibility.",
        },
        {
          image: "/assets/home/grab-mod-icon-18.webp",
          head: "Upload Required Documents",
          para: "Drivers can upload their license, vehicle registration, and other required documents directly through the app for fast verification by the admin.",
        },
        {
          image: "/assets/home/grab-mod-icon-7.webp",
          head: "Wallet Request",
          para: "Drivers can request wallet withdrawals, transferring their in-app earnings to linked Vietnamese bank accounts or popular local e-wallets like MoMo.",
        },
        {
          image: "/assets/home/grab-mod-icon-9.webp",
          head: "Earnings Dashboard",
          para: "A detailed earnings summary is available for drivers, showing daily income, trip count, and performance statistics — helping drivers track and maximize their earnings.",
        },
      ]
    },
    {
      name: "dispatcher dashboard",
      image: "/assets/home/bolt-developement-3.webp",
      boxes: [
        {
          image: "/assets/home/carvalue-3.webp",
          head: "Automatic Dispatching",
          para: "The system automatically assigns ride requests to the nearest available drivers, reducing passenger wait time and optimizing operations.",
        },
        {
          image: "/assets/home/grab-mod-icon-1.webp",
          head: "Booking Management",
          para: "Dispatchers can manage all ride bookings in real time, view ride statuses, and handle any special requests with ease.",
        },
        {
          image: "/assets/home/bla-rider-6.webp",
          head: "Smart Route Planning",
          para: "The system suggests optimized routes for drivers based on real-time traffic data, ensuring faster pickups and drop-offs.",
        },
        {
          image: "/assets/home/grab-mod-icon-2.webp",
          head: "Push Alerts for Dispatch",
          para: "Drivers receive instant push notifications when new ride requests are assigned, ensuring quick response times and better efficiency.",
        },
      ]
    },
    {
      name: "admin panel",
      image: "/assets/home/bolt-developement-4.webp",
      boxes: [
        {
          image: "/assets/home/grab-mod-icon-7.webp",
          head: "Add Wallet Balance",
          para: "Admins can manually add funds to customer or driver wallets for promotions, issue resolution, or compensation — ensuring smooth operations.",
        },
        {
          image: "/assets/home/bla-admin-4.webp",
          head: "Driver Supervision",
          para: "Admins can track driver activities, review their performance, and manage document verification — ensuring only approved, professional drivers operate on the platform.",
        },
        {
          image: "/assets/home/grab-mod-icon-20.webp",
          head: "Language Setting",
          para: "Admins can manage the app’s language settings, offering full Vietnamese language support for both drivers and customers.",
        },
        {
          image: "/assets/home/grab-mod-icon-9.webp",
          head: "In-Depth Analytics",
          para: "The admin dashboard provides detailed reports on ride statistics, revenue, user activity, and peak hours — empowering data-driven decisions to grow the business.",
        },
      ]
    },
  ]
}

const featureData = {
  titlePart1: "Must-Have Features of",
  titlePart2: "Grab Clone Taxi App",
  titlePart3: "for Vietnam",
  description: "Our Grab clone taxi app offers a robust set of features designed to help your business thrive in Vietnam’s fast-paced transportation sector.",
  boxes: [
    {
      image: "/assets/home/grab-feature-1.webp",
      heading: "Referral Program",
      description: "Encourage Vietnamese users to refer friends via Zalo, Facebook, or SMS, helping your app grow through trusted personal recommendations.",
    },
    {
      image: "/assets/home/grab-feature-2.webp",
      heading: "Flexible Fare Settings",
      description: "Set pricing based on time of day, location, distance, or vehicle type — ensuring profitability while staying competitive in Vietnam’s market.",
    },
    {
      image: "/assets/home/grab-feature-3.webp",
      heading: "Integrated Maps & Navigation",
      description: "Real-time Vietnamese map integration helps drivers and passengers navigate easily, especially in complex city layouts.",
    },
    {
      image: "/assets/home/grab-feature-4.webp",
      heading: "Transparent Ratings & Reviews",
      description: "Riders and drivers can rate each other after trips, ensuring trust, transparency, and continuous improvement in service quality.",
    },
    {
      image: "/assets/home/grab-feature-5.webp",
      heading: "Earning Reports",
      description: "Admins and drivers get access to comprehensive earnings reports, peak hours, and trip stats — all exportable for offline use.",
    },
    {
      image: "/assets/home/grab-feature-6.webp",
      heading: "Currency Management",
      description: "Supports VND (Vietnamese Dong) as the default currency, with options for real-time conversion if expanding to cross-border services in future.",
    },
  ]
}

const needData = {
  titlePart1: "Taxi",
  titlePart2: "App Development Solutions",
  titlePart3: "for Every Business Need",
  description: "Mobility Infotech offers custom taxi app development solutions tailored to meet the unique needs of various businesses.",
  boxes: [
    {
      image: "/assets/home/bolt-need-1.webp",
      title: "On-Demand Taxi Booking Apps",
      para: "Launch real-time taxi booking services with instant ride-matching, driver tracking, and secure payments. This is ideal for startups or local operators wanting to offer Grab-like convenience across Vietnam cities.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-2.webp",
      title: "Ride-sharing or Carpooling Apps",
      para: "Encourage eco-friendly, cost-efficient travel with ride-sharing solutions. Our app supports smart matching, split fares, and route optimisation — perfect for urban Vietnam commuters and sustainable transport initiatives.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-3.webp",
      title: "Corporate Taxi Booking Apps",
      para: "Offer streamlined, invoice-based travel for businesses. Our corporate taxi solutions allow employee ride management, usage tracking, and admin control, making it ideal for HR departments and enterprise mobility needs.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-4.webp",
      title: "Rental or Hourly Taxi Booking Apps",
      para: "Customers can hire drivers by the hour or for intercity rides. This model suits tourists, business travellers, and users needing flexibility without fixed destinations.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-5.webp",
      title: "Luxury & Limousine Booking Apps",
      para: "Cater to high-end clientele with premium car booking features, chauffeur tracking, and personalised experiences. Ideal for hospitality, events, and executive travel services across the Vietnam.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-6.webp",
      title: "Bike Taxi Booking Apps",
      para: "Target budget-conscious and solo commuters with efficient bike taxi services. Perfect for navigating traffic-heavy Vietnam city centres and last-mile delivery integration.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-7.webp",
      title: "White-Label Taxi Booking Apps",
      para: "Launch your taxi brand with our customisable, ready-to-deploy white label solutions. Includes your logo, colour scheme, and tailored features for a unique market presence.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-8.webp",
      title: "Airport Transfer Taxi Apps",
      para: "Streamline airport pickups and drop-offs with scheduling, flight tracking, and driver alerts. A perfect fit for travel companies and taxi fleets near major Vietnam airports.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-9.webp",
      title: "Electric Vehicle (EV) Taxi Apps",
      para: "Promote green mobility with EV-specific booking apps, charging point integration, and low-emission ride options — supporting the Vietnam’s shift towards sustainable transportation.",
      btn: "Request a free demo",
    },
    {
      image: "/assets/home/bolt-need-10.webp",
      title: "Paratransit or Accessible Taxi Apps",
      para: "Serve passengers with mobility needs through accessible vehicle support, driver assistance features, and booking options that meet Vietnam disability service standards.",
      btn: "Request a free demo",
    },
  ],
}

const driveData = {
  titlePart1: "Drive Your Success with the Vietnam’s",
  titlePart2: "Leading Taxi App Development Experts",
  description: "Embrace innovation with our next-gen taxi app solutions and watch your business accelerate like never before.",
  image: "/assets/home/bolt-drive.webp",
  vector: "/assets/home/bolt-drive-vec.webp",
  boxes: [
    {
      image: "/assets/home/drive-circle-1.webp",
      title: "60% Rise in Ride Bookings Per Quarter",
    },
    {
      image: "/assets/home/drive-circle-2.webp",
      title: "45% Reduction in Average Pickup Times",
    },
    {
      image: "/assets/home/drive-circle-3.webp",
      title: "35% Lower Operational Costs Across the Board",
    },
    {
      image: "/assets/home/drive-circle-4.webp",
      title: "44% Boost in Overall Revenue Generation",
    },
    {
      image: "/assets/home/drive-circle-5.webp",
      title: "75% Increase in Customer Loyalty and Repeat Usage",
    },
    {
      image: "/assets/home/drive-circle-6.webp",
      title: "58% Growth in Positive Customer Feedback Each Quarter",
    },
  ],
}

const journeyData = {
  titlePart1: "Our Taxi App Development Process That",
  titlePart2: "Drives Your Business Forward",
  description: "Planning to launch a Grab-like app? Understanding the operational flow is essential. Here's a streamlined look at how our Grab Clone App works to ensure seamless service and user satisfaction:",
  image: "/assets/home/bolt-journey.webp",
  vector: "/assets/home/bolt-journey-vec.webp",
}

const WhiteData = {
  title: "Develop Your White-Label Taxi Dispatch App with Mobility Infotech",
  description: "With over a decade of experience and the latest technology, Mobility Infotech helps you launch a fully customised Grab Clone App tailored for the Vietnam market.",
  boxes: [
    {
      image: "/assets/home/bolt-white-1.webp",
      title: "White-Label Solution",
      desc: "Outperform your competition with advanced features integrated into your white-label taxi booking app.",
    },
    {
      image: "/assets/home/bolt-white-2.webp",
      title: "Ready To Use",
      desc: "Get your app live in under 3 days and multiply your taxi booking revenue.",
    },
    {
      image: "/assets/home/bolt-white-3.webp",
      title: "Highly Scalable",
      desc: "Our solution grows with your business—scale locally or internationally without limits.",
    },
    {
      image: "/assets/home/bolt-white-4.webp",
      title: "Seamless Integration",
      desc: "Effortlessly connect with your existing payment gateways, third-party services, and operational systems.",
    },
    {
      image: "/assets/home/bolt-white-5.webp",
      title: "Fully Customizable",
      desc: "Customise every feature and design element to match your business needs and brand identity.",
    },
    {
      image: "/assets/home/bolt-white-6.webp",
      title: "User-Friendly Interface",
      desc: "Designed for intuitive use, delivering a seamless experience to both drivers and passengers.",
    },
  ]
}

const globalData = {
  titlePart1: "Proven Impact from",
  titlePart2: "Our Taxi App ",
  titlePart3: "Development",
  counter1: {
    number: "70",
    text: "Increase in Potential ROI",
  },
  counter2: {
    number: "64",
    text: "Increase in Customer Satisfaction",
  },
  counter3: {
    number: "40",
    text: "Increase in Bookings",
  },
  counter4: {
    number: "20",
    text: "Reduction in Maintenance Costs",
  },
}

const faqData = [
  {
    id: "0",
    question: "01. What is the Grab Clone Taxi App by Mobility Infotech?",
    answer: "The Grab Clone Taxi App by Mobility Infotech is a ready-made, customizable mobile application that allows businesses in Vietnam to launch their own ride-hailing and transport services. It includes features for booking car rides, motorbike taxis (xe ôm), parcel delivery, and more — all within a single, easy-to-manage platform.",
  },
  {
    id: "1",
    question: "02. Can this app be customized for my specific city or region in Vietnam?",
    answer: "Yes, absolutely! The app is fully customizable to support operations in specific cities or regions across Vietnam, such as Hanoi, Ho Chi Minh City, Da Nang, or even smaller towns. You can set service zones, pricing, language, and currency to suit your target market.",
  },
  {
    id: "2",
    question: "03. Does the app support Vietnamese language and local payment options?",
    answer: "Yes, the app is designed with full Vietnamese language support for customers, drivers, and admins. It also integrates with popular local payment methods like MoMo, ZaloPay, and direct bank transfers for smooth, cashless transactions.",
  },
  {
    id: "3",
    question: "04. How can drivers and customers sign up on the platform?",
    answer: "Both drivers and customers can easily register through the mobile app. Social media sign-up options like Zalo or Facebook are available for customers, while drivers can upload necessary documents like their license and vehicle details for admin approval.",
  },
  {
    id: "4",
    question: "05. Can I offer other services like parcel delivery along with taxi rides?",
    answer: "Yes, the Grab Clone Taxi App is a multi-service platform. You can provide ride-hailing, bike taxi, parcel delivery, and other on-demand services all within the same app, giving your business flexibility to grow beyond just transport.",
  },
  {
    id: "5",
    question: "06. How does the app help me manage payments and earnings?",
    answer: "The app includes integrated e-wallets for customers and drivers, real-time fare calculation, and automated earning reports. As an admin, you can track revenue, peak hour performance, and payouts seamlessly from the backend dashboard.",
  },
  {
    id: "6",
    question: "07. Is technical support available after purchasing the app?",
    answer: "Yes, Mobility Infotech offers ongoing technical support, app maintenance, and updates to ensure your platform runs smoothly. Our team is available to assist with setup, customization, and troubleshooting whenever required.",
  },

];

export default function GrabClone() {
  const [isScroll, setIsScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsScroll(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <>
      <GrabBanner data={HeadData} />
      <GrabMulti data={multiData} />

      <Suspense fallback={<div style={{ height: '100vh' }} />}>
        <GrabModule data={moduleData} />
        {isScroll && (
          <>
            <GrabFeature data={featureData} />
            <BoltNeed data={needData} />
            <BoltDrive data={driveData} />
            <div className="grab-journey">
              <BoltJourney data={journeyData} />
            </div>
            <BoltWhiteLabel data={WhiteData} />
            <BoltGlobal data={globalData} />
            <ShuttleAppreciation />
            <div className="zip-faq-fixer">
              <TaxiFaq faqData={faqData} />
            </div>
          </>
        )}
      </Suspense>
    </>
  )
}
